import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { MONTHS_FR_FULL, isMonthFullyDisabled } from './utils';

interface MonthPickerProps {
  year: number;
  selectedMonth: number;
  minDate?: Date;
  maxDate?: Date;
  onMonthSelect: (month: number) => void;
  onYearChange: (delta: number) => void;
  onSwitchToYears: () => void;
}

export function MonthPicker({
  year,
  selectedMonth,
  minDate,
  maxDate,
  onMonthSelect,
  onYearChange,
  onSwitchToYears,
}: MonthPickerProps) {
  return (
    <div className="w-[280px] p-2">
      <div className="mb-3 flex items-center justify-between">
        <button
          onClick={() => onYearChange(-1)}
          className="rounded p-1 text-neutral-400 transition-colors hover:bg-neutral-100 hover:text-neutral-600"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <button
          onClick={onSwitchToYears}
          className="text-sm font-semibold text-dark-500 hover:text-primary-500 transition-colors"
        >
          {year}
        </button>
        <button
          onClick={() => onYearChange(1)}
          className="rounded p-1 text-neutral-400 transition-colors hover:bg-neutral-100 hover:text-neutral-600"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {MONTHS_FR_FULL.map((monthName, idx) => {
          const disabled = isMonthFullyDisabled(year, idx, minDate, maxDate);
          const isSelected = idx === selectedMonth;
          return (
            <button
              key={monthName}
              onClick={() => !disabled && onMonthSelect(idx)}
              disabled={disabled}
              className={cn(
                'rounded-lg px-2 py-2 text-sm transition-colors',
                disabled && 'text-neutral-200 cursor-not-allowed',
                !disabled && !isSelected && 'text-dark-500 hover:bg-primary-50 hover:text-primary-600',
                isSelected && !disabled && 'bg-primary-500 text-white font-semibold'
              )}
            >
              {monthName.slice(0, 4)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
